import { useState, useCallback } from 'react';

const ONBOARDING_KEY = 'kuadra2-onboarding-complete';

export function useOnboarding() {
  const [completed, setCompleted] = useState(() => {
    return localStorage.getItem(ONBOARDING_KEY) === 'true';
  });

  const shouldShowOnboarding = !completed;

  const completeOnboarding = useCallback(() => {
    localStorage.setItem(ONBOARDING_KEY, 'true');
    setCompleted(true);
  }, []);

  return { shouldShowOnboarding, completeOnboarding };
}
